import React, { useState } from 'react';
import { CalcCard, CalcField, ResultStat, GrowthChart, CalcFooter, formatINR, SERIES_INVESTED, SERIES_VALUE } from './shared';

export const LumpsumCalculator = () => {
  const [amount, setAmount] = useState(100000);
  const [years, setYears] = useState(10);
  const [rate, setRate] = useState(12);

  const y = Math.max(1, Math.round(years));
  const data = Array.from({ length: y }, (_, i) => ({
    label: `Yr ${i + 1}`,
    invested: amount,
    value: amount * Math.pow(1 + rate / 100, i + 1),
  }));
  const { value } = data[data.length - 1];

  return (
    <CalcCard title="Lumpsum Calculator" subtitle="Estimate how a one-time investment may grow over time." testId="lumpsum-calculator">
      <div className="space-y-6 mb-8">
        <CalcField label="Investment Amount (₹)" value={amount} onChange={setAmount} min={5000} max={10000000} step={5000} testId="lumpsum-amount" />
        <CalcField label="Investment Period (Years)" value={years} onChange={setYears} min={1} max={40} testId="lumpsum-years" />
        <CalcField label="Assumed Annual Return (%) – illustrative" value={rate} onChange={setRate} min={1} max={20} step={0.5} testId="lumpsum-returns" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <ResultStat label="Total Invested" value={formatINR(amount)} testId="lumpsum-invested-result" />
        <ResultStat label="Illustrative Gains" value={formatINR(value - amount)} testId="lumpsum-gains-result" accent />
        <ResultStat label="Illustrative Future Value" value={formatINR(value)} testId="lumpsum-future-result" />
      </div>
      <GrowthChart data={data} series={[SERIES_INVESTED, SERIES_VALUE]} testId="lumpsum-chart" />
      <CalcFooter testId="lumpsum" />
    </CalcCard>
  );
};
